"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFromRaw = parseFromRaw;
exports.parseFromShiftRaw = parseFromShiftRaw;
const branchSettings_1 = require("../../model/v1/branchSettings");
const common_1 = require("../../js/common");
function parseFromRaw(rawSettings) {
    const req = {
        timeZone: rawSettings.TimeZone,
    };
    let scheduleStartDate = undefined;
    if (rawSettings.ScheduleStartDate && !(0, common_1.isZeroDate)(new Date(rawSettings.ScheduleStartDate))) {
        scheduleStartDate = new Date(rawSettings.ScheduleStartDate);
    }
    let shiftLockDate = undefined;
    if (rawSettings.ShiftLockDate && !(0, common_1.isZeroDate)(new Date(rawSettings.ShiftLockDate))) {
        shiftLockDate = new Date(rawSettings.ShiftLockDate);
    }
    const opt = {
        requestOff: rawSettings.RequestOff,
        roleRequestOff: rawSettings.RoleRequestOff,
        scheduleEnabled: rawSettings.ScheduleEnabled,
        scheduleCustomEnabled: rawSettings.ScheduleCustomEnabled,
        scheduleLength: rawSettings.ScheduleLength,
        scheduleStartDate: scheduleStartDate,
        shiftHalfPTOText: rawSettings.ShiftHalfPTOText,
        shiftOffText: rawSettings.ShiftOffText,
        shiftPTOText: rawSettings.ShiftPTOText,
        shiftStaffOffText: rawSettings.ShiftStaffOffText,
        shiftWorkText: rawSettings.ShiftWorkText,
        showRoleTimes: rawSettings.ShowRoleTimes,
        splitNightShift: rawSettings.SplitNightShift,
        staffLock: rawSettings.StaffLock,
        stackedRequest: rawSettings.StackRequestSlots,
        yearStart: rawSettings.StartOfYear,
        weekStart: rawSettings.StartOfWeek,
        monthStart: rawSettings.StartOfMonth,
        summaryDayStart: rawSettings.SummaryDayStart,
        summaryDayEnd: rawSettings.SummaryDayEnd,
        shiftLockDate: shiftLockDate,
        closedWeekdays: rawSettings.ClosedWeekdays,
        isLaborInSummaryPage: rawSettings.ShowLabor,
        isPTOCountInSummaryPage: rawSettings.ShowPTOCount,
        isVacationCountInSummaryPage: rawSettings.ShowVacationCount,
        isWorkCountInSummaryPage: rawSettings.ShowWorkCount,
        memoSummary: rawSettings.ShowMemo,
        overtimeStartTimeHours: rawSettings.OvertimeStartTimeHours,
        overtimeStartTime: rawSettings.OvertimeStartTime,
        shiftInterval: rawSettings.ShiftInterval,
        profilePhotoEnabled: rawSettings.ProfilePhotoEnabled,
    };
    const settings = new branchSettings_1.BranchSettings(req, opt);
    return settings;
}
function parseFromShiftRaw(rawSettings) {
    const req = {
        timeZone: rawSettings.TimeZone,
    };
    const opt = {
        requestOff: rawSettings.RequestOff,
        roleRequestOff: rawSettings.RoleRequestOff,
        shiftHalfPTOText: rawSettings.ShiftHalfPTOText,
        shiftOffText: rawSettings.ShiftOffText,
        shiftPTOText: rawSettings.ShiftPTOText,
        shiftStaffOffText: rawSettings.ShiftStaffOffText,
        staffLock: rawSettings.StaffLock,
        shiftWorkText: rawSettings.ShiftWorkText,
        showRoleTimes: rawSettings.ShowRoleTimes,
        splitNightShift: rawSettings.SplitNightShift,
        stackedRequest: rawSettings.StackRequestSlots,
        yearStart: rawSettings.StartOfYear,
        weekStart: rawSettings.StartOfWeek,
        monthStart: rawSettings.StartOfMonth,
        summaryDayStart: rawSettings.DayViewFrom,
        summaryDayEnd: rawSettings.DayViewTo,
        shiftLockDate: rawSettings.ShiftLockDate,
        closedWeekdays: rawSettings.ClosedWeekdays,
    };
    const settings = new branchSettings_1.BranchSettings(req, opt);
    return settings;
}
